import { capitalize } from 'lodash';

import { PROVIDER_KEY_TO_NAME } from 'src/shared/constants';

import type { OauthIntegrationProviderEnum } from 'src/graphql/schema';

export const getProviderDisplayName = (provider: string | undefined): string => {
  if (!provider) return 'Unknown';

  return provider in PROVIDER_KEY_TO_NAME
    ? PROVIDER_KEY_TO_NAME[provider as OauthIntegrationProviderEnum]
    : capitalize(provider);
};
